// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import 'firebase/storage';
import firebase from 'firebase/app';

//COMPONENT
class ShelfItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewURL: ''
        };

        this.showimage = this.showimage.bind(this);
        this._isMounted = false;
    }

    componentDidMount(){
        this.showimage();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    showimage() {
        firebase.storage().ref().child('preview-images/' + this.props.item['preview-image']).getDownloadURL().then(function(url) {
            this._isMounted && this.setState({previewURL: url});
        }.bind(this)).catch(function(error) {
            console.log(error);
        });
    }

    render() {
        return (
            <div>
                <div className="product-in-shelf">
                    <div className="product-in-shelf-details">
                        <img className='segment-image noselect' src={this.state.previewURL == '' ? require('../../../images/empty-preview.png') : this.state.previewURL}/>
                    </div>
                </div>
            </div>
        );
    }
}

ShelfItem.propTypes = {
    history: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};

const hoc = withRouter(ShelfItem);

// EXPORT COMPONENT
export { hoc as ShelfItem };


// WEBPACK FOOTER //
// ./src/components/pages/Planograms/ShelfItem.js